module.exports = "<span class=day-date-title>{{dayDate}}</span> <div class=day-schedule-list> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/calendar/calendar.main/calendar.schedule/calendar.schedule.item/calendar.schedule.item.html
// module id = 4952
// module chunks = 50